/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetConnectWifiIcon16Regular = forwardRef('NetConnectWifiIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.001 4.25a7.75 7.75 0 0 0-5.794 2.602.75.75 0 1 1-1.12-.997 9.25 9.25 0 0 1 13.83.002.75.75 0 1 1-1.122.997A7.75 7.75 0 0 0 8 4.25Z" }),
        React.createElement("path", { d: "M8.003 8.25A3.75 3.75 0 0 0 5.07 9.661a.75.75 0 0 1-1.172-.936 5.25 5.25 0 0 1 8.212.008.75.75 0 1 1-1.174.933A3.75 3.75 0 0 0 8.003 8.25Z" }),
        React.createElement("path", { d: "M8 13.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z" })));
});
